export default __webpack_public_path__ + "static/media/BMWGroupCondensed-Regular.5b75df75.woff2";